export default function Arrow2({ color = '#f0211d' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16.715" height="25.073" viewBox="0 0 16.715 25.073">
      <g id="chevron-down-r" transform="translate(-7.285 24) rotate(-90)">
        <path id="Path_274" data-name="Path 274" d="M7.757,13.35l4.179-4.179,8.358,8.358,8.358-8.358L32.83,13.35,20.294,25.887Z" transform="translate(-8.83 -1.886)" fill={color} />
      </g>
    </svg>
  );
}
